<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { EnergyTariff } from 'src/types/EnergyTariff';
	import { Text } from '@Shelly/shelly-design-system';

	export let tariff: EnergyTariff;
	export let variant: 'light' | 'dark' = 'light';
</script>

{#if tariff.priceGuaranteeMonths || tariff.initialTermMonths}
	<div
		class="tariff-contract-details"
		class:variant-light={variant === 'light'}
		class:variant-dark={variant === 'dark'}
	>
		{#if tariff.priceGuaranteeMonths}
			<Text styleType="body-small" class="contract-item">
				{$format('label_price_guarantee', {
					default: 'Preisgarantie: {months} Monate',
					values: { months: tariff.priceGuaranteeMonths.toString() },
					locale: 'de',
				})}
			</Text>
		{/if}
		{#if tariff.initialTermMonths}
			<Text styleType="body-small" class="contract-item">
				{$format('label_initial_term', {
					default: 'Mindestlaufzeit: {months} Monate',
					values: { months: tariff.initialTermMonths.toString() },
					locale: 'de',
				})}
			</Text>
		{/if}
	</div>
{/if}

<style>
	.tariff-contract-details {
		display: flex;
		flex-direction: column;
		gap: 1px;
		margin-top: 2px;
	}

	.contract-item {
		color: var(--color-text-primary, #000000);
		font-size: 10px;
		line-height: 1.2;
		margin: 0;
	}

	.tariff-contract-details.variant-light .contract-item {
		color: rgba(255, 255, 255, 0.9);
	}

	.tariff-contract-details.variant-dark .contract-item {
		color: var(--color-text-primary, #000000);
	}
</style>
